module.exports = __webpack_public_path__ + "0e31cabc60f413eea0c3a8a791989d70.png";